/**
 * The Symagic Server Appointment entity.
 * @author Tom Verschoore de la Houssaije
 */
import { EntityQuery, EntityState } from 'breeze-client';
import * as moment from 'moment';
/**
 * The Symagic Server Appointment entity.
 */
var Appointment = /** @class */ (function () {
    function Appointment() {
    }
    Object.defineProperty(Appointment.prototype, "TotalSpend", {
        /**
         * Gets the sum of the time booked on this Appointment.
         * There is a server-side property ActualSpend with the same meaning.
         * We choose to calculate client-side for instant user feedback.
         * @type {string}
         */
        get: function () {
            if (!this.entityAspect || !this.entityAspect.entityManager) {
                return 'PT0S';
            }
            if (this.entityAspect.entityState === EntityState.Added) {
                return 'PT0S';
            }
            var entityQuery = EntityQuery.from('SpendTimeItems').where('Account_Oid', 'equals', this['Oid']);
            var data = this.entityAspect.entityManager.executeQueryLocally(entityQuery);
            if (data.length === 0) {
                return 'PT0S';
            }
            var sum = 0;
            data.map(function (it) { return it; }).forEach(function (item) {
                sum += moment.duration(item.Effort).asMinutes() * item.SumFactor;
            });
            return moment.duration(sum, 'minutes').toISOString();
        },
        /**
         * Sets nothing. Only needed for angular binding.
         */
        set: function (value) {
            // Make it a read/write property to enable twoway binding.
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Appointment.prototype, "Duration", {
        /**
         * Gets the duration of the appointment.
         * @readonly
         * @type {string}
         */
        get: function () {
            if (!this.entityAspect) {
                return 'PT0S';
            }
            if (!this.Finish || !this.Start) {
                return 'PT0S';
            }
            var start = moment(this.Start);
            var finish = moment(this.Finish);
            if (start.isAfter(finish)) {
                return 'PT0S';
            }
            var result = moment.duration(finish.diff(start));
            return result.toISOString();
        },
        /**
         * Sets nothing. Only needed for angular binding.
         */
        set: function (value) {
            // Make it a read/write property to enable twoway binding.
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Calculates the effort by factoring the ratio of overlap with a given timeslot.
     * @param {moment.Moment} start The start of the timeslot
     * @param {moment.Moment} finish The finish of the timeslot.
     * @returns {number} The effort ratio in seconds
     */
    Appointment.prototype.overlapEffort = function (start, finish) {
        var factor = this.SumFactor;
        if (factor === 0) {
            return 0;
        }
        if (start.isSameOrAfter(this.Finish)) {
            return 0;
        }
        if (finish.isSameOrBefore(this.Start)) {
            return 0;
        }
        var planStart = moment(this.Start);
        var planFinish = moment(this.Finish);
        var overlapStart = start.isAfter(planStart) ? start : planStart;
        var overlapFinish = finish.isBefore(planFinish) ? finish : planFinish;
        var overlap = moment.duration(overlapFinish.diff(overlapStart)).asSeconds();
        var hoursOfLeave = moment.duration(this.HoursOfLeave).asSeconds();
        var duration = moment.duration(planFinish.diff(planStart)).asSeconds();
        if (duration === 0 || (start.isSameOrBefore(this.Start) && finish.isSameOrAfter(this.Finish))) {
            // Ik kan de gehele werkdruk geven want
            // de Assignment valt binnen de getoonde periode
            return factor * hoursOfLeave;
        }
        // Ik geef de fractie (overlap / duration) van de werkdruk want
        // de Assignment is groter dan de getoonde periode.
        return factor * (overlap / duration) * hoursOfLeave;
    };
    return Appointment;
}());
export { Appointment };
